module.exports = __webpack_public_path__ + "static/img/icon_ldy_LOGO.bcdf6025.png";